import { forwardRef } from '@chakra-ui/react';
import { IconButton, IconButtonProps } from '@chakra-ui/react';
import React from 'react';

export const CmIconButton = forwardRef<IconButtonProps, 'button'>(
  // @ts-ignore TS2590
  ({ ...rest }, ref) => {
    // @ts-ignore TS2590
    return <IconButton {...{ ...rest, ref }} />;
  }
);
